import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import TextField from '@material-ui/core/TextField'
import CustomDialog from '../custom-material/dialog/Dialog'
import CustomDialogTitle from '../custom-material/dialog/DialogTitle'
import CustomButton, { CancelCustomButton } from '../custom-material/button/Button'
import CustomTypography, { CenteredCustomTypography } from '../custom-material/typography/Typography'

const styles = theme => ({
  dialog: {
    maxWidth: 400
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 16
  },
  fieldRowContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12
  },
  fieldRowLabel: {
    marginRight: 8
  },
  input: {
    fontSize: '1em',
    border: '1px solid rgba(0, 0, 0, 0.42)',
    borderBottom: 0,
    borderRadius: 2,
    marginTop: '28px !important',
    padding: 3
  },
  inputText: {
    overflow: 'hidden'
  },
  inputShrinkLabel: {
    fontWeight: 600,
    color: '#003368'
  },
  selectInputBase: {
    outline: '1px solid rgba(0, 0, 0, 0.42)',
    marginTop: '29px !important'
  },
  selectInputRoot: {
    fontSize: 15,
    height: 30
  },
  selectInput: {
    paddingLeft: 3
  },
  selectMenu: {
    paddingLeft: 3,
    height: 16,
    display: 'flex',
    alignItems: 'center'
  },
  selectMenuItem: {
    fontSize: 15
  },
  selectMenuItemEmpty: {
    color: 'rgba(0, 0, 0, 0.42)',
    fontSize: 14
  },
  actionContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 12
  }
})

class RequestUserDeactivationDialogComponent extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      deactivationReason: '',
      otherExplanation: '',
      comments: '',
      showConfirmation: false
    }

    this.handleChange = key => event => this.setState({[key]: (event.target && event.target.value) || ''})
    this.showConfirmation = () => this.setState(prevState => ({showConfirmation: !prevState.showConfirmation}))
  }

  render () {
    const { deactivationReason, otherExplanation, comments, showConfirmation } = this.state
    const { classes, dialogOpen, handleCloseDialog, saveDeactivate } = this.props
    return (
      <CustomDialog classes={{paper: classes.dialog}} open={dialogOpen} onClose={handleCloseDialog} aria-labelledby='updates-dialog-title'>
        <CustomDialogTitle id='updates-dialog-title' disableTypography>Request to Deactivate Account</CustomDialogTitle>
        {showConfirmation
          ? <div className={classes.contentContainer}>
            <CenteredCustomTypography variant='body1' paragraph>
              <strong>You have successfully requested <br /> your account deactivation.</strong>
            </CenteredCustomTypography>
            <CenteredCustomTypography variant='body1' paragraph>
              You will receive an email within <br /> 24 business hours to confirm your request.
            </CenteredCustomTypography>
            <div className={classes.actionContainer}>
              <CustomButton
                variant='contained'
                size='small'
                color='secondary'
                
                onClick={handleCloseDialog}
              >
                OK
              </CustomButton>
            </div>
          </div>
          : <div className={classes.contentContainer}>
            <div className={classes.fieldRowContainer}>
              <CustomTypography>
                {
                  `We need a little more information about
                  your request to deactivate your account.`
                }
              </CustomTypography>
            </div>
            <div className={classes.fieldRowContainer}>
              <FormControl required error={!deactivationReason} fullWidth>
                <InputLabel shrink classes={{shrink: classes.inputShrinkLabel}} htmlFor='reason-select'>Please choose removal reason</InputLabel>
                <Select
                  className={classes.selectInputBase}
                  value={deactivationReason || ''}
                  onChange={this.handleChange('deactivationReason')}
                  MenuProps={{classes: {paper: classes.selectMenuPaper}}}
                  classes={{selectMenu: classes.selectMenu}}
                  disableUnderline
                  displayEmpty
                  error={!deactivationReason}
                  inputProps={{
                    name: `deactivate-reason`,
                    id: `deactivate-reason-select`,
                    classes: {
                      root: classes.selectInputRoot
                    }
                  }}
                >
                  <MenuItem value=''>
                    <span className={classes.selectMenuItemEmpty}>Removal Reason</span>
                  </MenuItem>
                  <MenuItem className={classes.selectMenuItem} value='No longer with company'>No longer with company</MenuItem>
                  <MenuItem className={classes.selectMenuItem} value='No longer with this division'>No longer with this division</MenuItem>
                  <MenuItem className={classes.selectMenuItem} value='No longer in this role'>No longer in this role</MenuItem>
                  <MenuItem className={classes.selectMenuItem} value='Content not relevant'>Content not relevant</MenuItem>
                  <MenuItem className={classes.selectMenuItem} value='Other'>Other</MenuItem>
                </Select>
              </FormControl>
            </div>
            {deactivationReason === 'Other'
              ? <div className={classes.fieldRowContainer}>
                <TextField
                  id='otherExplanation'
                  label='Other, please explain:'
                  required
                  error={!otherExplanation}
                  value={otherExplanation || ''}
                  InputProps={{classes: {root: classes.input, input: classes.inputText}}}
                  InputLabelProps={{shrink: true, classes: {shrink: classes.inputShrinkLabel}}}
                  fullWidth
                  onChange={this.handleChange('otherExplanation')}
                />
              </div>
              : null
            }
            <div className={classes.fieldRowContainer}>
              <TextField
                id='comments'
                label='Comments:'
                value={comments || ''}
                InputProps={{classes: {root: classes.input, input: classes.inputText}}}
                InputLabelProps={{shrink: true, classes: {shrink: classes.inputShrinkLabel}}}
                fullWidth
                multiline
                rows='2'
                rowsMax='2'
                onChange={this.handleChange('comments')}
              />
            </div>
            <div className={classes.actionContainer}>
              <CancelCustomButton style={{marginRight: 8}} variant='contained' size='small' color='default'  onClick={handleCloseDialog}>Cancel</CancelCustomButton>
              <CustomButton
                variant='contained'
                size='small'
                color='secondary'
                
                disabled={!deactivationReason || (deactivationReason === 'Other' && !otherExplanation)}
                onClick={() => { saveDeactivate(comments, otherExplanation, deactivationReason); this.showConfirmation() }}
              >
                Submit
              </CustomButton>
            </div>
          </div>
        }
      </CustomDialog>
    )
  }
}

RequestUserDeactivationDialogComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogOpen: PropTypes.bool,
  handleCloseDialog: PropTypes.func,
  saveDeactivate: PropTypes.func
}

export default withStyles(styles)(RequestUserDeactivationDialogComponent)
